import styled from "styled-components";

export const TreeWrapper = styled.ul`
  padding-left: 0;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin: 0;
  .arrow {
    width: 2rem;
    height: 2rem;
    display: flex;
    place-content: center;
    align-items: center;
  }
  .arrow-hover: hover {
    background: var(--BORDER);
    border-radius: 4px;
  }
  .folder {
    align-items: center;
    padding: 0.6rem 0.8rem;
    border-radius: 0.6px;
    gap: 0.7rem;
  }
  .tree {
    cursor: pointer;
    gap: 0.6rem;
    align-items: center;
    font-size: 1.4rem;
    font-weight: 300;
    color: var(--NODE-TEXT);
    width: auto;
    flex-wrap: nowrap;
    .arrow-hide {
      visibility: hidden;
    }

    .name,
    .arrow,
    svg {
      flex-shrink: 0;
    }
    .active {
      padding: 0.2rem 0.8rem;
      background: var(--PRIMARY);
      color: var(--WHITE);
      border-radius: 4px;
      font-weight: 500 !important;
    }
    .text-bold {
      font-weight: 600;
    }
    .arrow-down {
      transform: rotate(90deg);
    }
    &:hover {
      .folder {
        background: var(--FOLDER-NODE-BG-HOVER);
        border-radius: 6px;
      }
      .space {
        visibility: visible;
      }
    }
    .space {
      visibility: hidden;
      margin-left: 3rem;
    }
  }
  .sub-nodes {
    margin-left: 1.5rem;
  }

  .active-node {
    .folder {
      // background: #f1f7ff;
      background: var(--LIGHT-ACCENT-COLOR);
      border-radius: 6px;
      &: hover {
        background: var(--LIGHT-ACCENT-COLOR);
      }
    }
    .space {
      visibility: visible !important;
    }
  }
`;
